import { render, staticRenderFns } from "./PurchaseAging.vue?vue&type=template&id=78831c61"
import script from "./PurchaseAging.vue?vue&type=script&lang=js"
export * from "./PurchaseAging.vue?vue&type=script&lang=js"
import style0 from "./PurchaseAging.vue?vue&type=style&index=0&id=78831c61&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports